import React from 'react';
import { View } from 'react-native';

import { Text, VStack } from '@squire/ui';

import { ExclamationMarkIcon, InfoIcon } from '@/components/_icons';

import { CheckIcon } from '../../_icons/CheckIcon';
import { styles } from './styles';
import type { ToastItemProps } from './types';

const ToastItem = ({ toast }: ToastItemProps) => {
  const { message, variant = 'info', description, hideIcon = false } = toast;

  styles.useVariants({ variant });

  const renderIcon = () => {
    switch (variant) {
      case 'success':
        return <CheckIcon size={16} color="iconStatic" />;
      case 'error':
        return <ExclamationMarkIcon size={16} color="iconStatic" />;
      case 'info':
      default:
        return <InfoIcon size={16} color="iconPrimaryInverse" />;
    }
  };

  return (
    <View
      style={styles.toastContainer}
      accessibilityRole="alert"
      accessibilityLiveRegion="polite"
    >
      {!hideIcon && (
        <View style={styles.iconCircle}>
          <View style={styles.iconHalo} />
          {renderIcon()}
        </View>
      )}
      <VStack flex>
        <Text variant="m" style={styles.message}>
          {message}
        </Text>
        {!!description && (
          <Text variant="s" style={styles.description}>
            {description}
          </Text>
        )}
      </VStack>
    </View>
  );
};

ToastItem.displayName = 'ToastItem';

export { ToastItem };
